import { useQuery } from 'react-query'

import { QueryKeys } from 'constants/queries'
import { getCourseById } from 'api/lectures'
import { GetCourseByIdResponse } from 'models/lectures/ApiModels/lectures'
import { CourseById } from 'models/lectures/EntityModels/lectures'
import { deserializeCourse } from 'serializers/lectures'

const useGetCourse = (id: number) =>
  useQuery([QueryKeys.COURSE, { id }], getCourseById, {
    select: (data: GetCourseByIdResponse): CourseById => deserializeCourse(data)
  })

export default useGetCourse
